'use client';

import { useContext } from 'react';
import { GeoContext, type GeoContextValue } from './context';

export function useGeo(): GeoContextValue {
  const context = useContext(GeoContext);
  if (!context) throw new Error('useGeo must be used within a GeoProvider');
  return context;
}
